import React from 'react';
import { Load } from '../../../../types';
import { DisplayStopTableRow } from './display-stop-table-row';

interface DisplayLoadStopsProps {
    load: Load;
}

export const DisplayLoadStops: React.FC<DisplayLoadStopsProps> = (props) => {
    const { load } = props;

    return (
        <>
            {load.stops.map((stop, i) => {
                return (
                    <DisplayStopTableRow
                        key={stop.id || i} // auto merged stops have an undefined id
                        stop={stop}
                        trailerId={load.trailerId}
                    />
                );
            })}
        </>
    );
};
